import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";

import { ArrowLeft } from "react-feather";

const OverlayModal = ({bottom, opened, className, instant, title, children, onClose, classBody="", bg='#fff'})=> {


  const [bodyOffset, setBodyOffset] = useState(0);

  const bodyRef = useRef();

  useEffect(()=> {
    if(bottom) return;
    if(opened && !bottom) {
      setTimeout(()=> {
        setBodyOffset(bodyRef.current.getBoundingClientRect().top);
      }, 500);
    }
    document.body.style.overflowY = opened ? "hidden" : "auto";
    opened && window.scrollTo({top: 0});
    return ()=> document.body.style.overflowY = 'auto';
  }, [opened]);


  const closeBottom = (e)=> {
    e.stopPropagation();
    if(bottom) onClose();
  };

  return (

    <div className={classNames("modal-overlay", { opened, bottom, instant }, [className] )} onClick={closeBottom}>

      {title && <h5 className="title" style={{backgroundColor: bg}}>
        <ArrowLeft className="pull-left back" onClick={onClose} /> { title }
      </h5> }

      <div className={classNames("body", classBody)} style={{backgroundColor: bg, ...(!bottom ? {minHeight: `calc(100vh -  ${bodyOffset}px`}: {})} } ref={bodyRef}>
        { children }
      </div>
    </div>
  );
};

export default OverlayModal;
